import React, { useState, useEffect, Suspense } from 'react';
import { auth } from './firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';

import Navbar from './components/Navbar';
import Dashboard from './components/Dashboard';
import Login from './components/Login';

const TodoList = React.lazy(() => import('./components/TodoList'));

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const renderContent = () => {
    const path = window.location.pathname;
    if (path.startsWith('/l/')) {
      const shortName = path.split('/l/')[1];
      return (
        <Suspense fallback={<div className="flex justify-center items-center h-screen">Caricamento lista...</div>}>
          <TodoList shortName={shortName} user={user} />
        </Suspense>
      );
    }
    return user ? <Dashboard user={user} /> : <Login />;
  };

  if (loading) {
    return <div className="flex justify-center items-center h-screen">Caricamento...</div>;
  }

  return (
    <div className="min-h-screen bg-gray-100 font-sans">
      <Navbar user={user} />
      <main className="container mx-auto p-4">
        {renderContent()}
      </main>
    </div>
  );
}

export default App;